import * as e from "react";
const v = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("path", { fill: "#F7FCFF", d: "M0 0h32v24H0z" }),
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MT_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MT_svg__a)" }, /* @__PURE__ */ e.createElement("mask", { id: "MT_svg__b", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 4H6v2.993A1 1 0 005.233 8H2v4h3.332c.129.267.373.468.668.538V16h4v-3.449c.324-.054.595-.265.733-.551H14V8h-3.168v-.034A1 1 0 0010 6.98V4z"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 4H6v2.993A1 1 0 005.233 8H2v4h3.332c.129.267.373.468.668.538V16h4v-3.449c.324-.054.595-.265.733-.551H14V8h-3.168v-.034A1 1 0 0010 6.98V4z",
      fill: "#A0A0A0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 4V3H5v1h1zm4 0h1V3h-1v1zM6 6.993l.232.973L7 7.783v-.79H6zM5.233 8v1h1.034l-.035-1.034L5.233 8zM2 8V7H1v1h1zm0 4H1v1h1v-1zm3.332 0l.9-.435L5.959 11h-.627v1zm.668.538h1v-.79l-.768-.182-.232.972zM6 16H5v1h1v-1zm4 0v1h1v-1h-1zm0-3.449l-.167-.986-.833.141v.845h1zm.733-.551v-1h-.628l-.272.565.9.435zM14 12v1h1v-1h-1zm0-4h1V7h-1v1zm-3.168 0l-1-.034L9.797 9h1.034V8zM10 6.98H9v.845l.833.14L10 6.98zM6 5h4V3H6v2zm1 1.993V4H5v2.993h2zm-.768.973L5.768 6.02a2 2 0 00-1.536 1.946h2zm0 0h-2c0 .022 0 .045.002.068l1.998-.068zM2 9h3.233V7H2v2zm1 3V8H1v4h2zm2.332-1H2v2h3.332v-2zm.9.566v-.001l-1.8.87c.257.533.744.935 1.336 1.076l.464-1.945zM7 16v-3.462H5V16h2zm3-1H6v2h4v-2zm-1-2.449V16h2v-3.449H9zm1.167.986c.65-.11 1.19-.53 1.466-1.102l-1.8-.87.334 1.972zM14 11h-3.267v2H14v-2zm-1-3v4h2V8h-2zm-2.168 1H14V7h-3.168v2zm-1-1.034l1.999.068.001-.068h-2zm.001 0c-.002 0-.002-.002 0 0-.001-.001-.001-.002-.001 0h2a2 2 0 00-1.665-1.972l-.334 1.972zM9 4v2.98h2V4H9z",
      fill: "#FECA00",
      mask: "url(#MT_svg__b)"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 0h16v24H16V0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MT_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 16,
      y: 0,
      width: 16,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 0h16v24H16V0z",
        fill: "#fff"
      }
    )
  ))
), h = v;
export {
  h as default
};
